import React from 'react';
import styled from 'styled-components';
import { Button } from '@mui/material';

const Title = () => {
  return (
    <MainContainer name='home'>
      <ProfileImg src='/profilePhoto.jpeg' alt='profile-pic'></ProfileImg>

      <HeaderContainer>
        <div className='clinician-name'>Brandy Mak M.S., CCC-SLP,</div>
        <div className='clinician-title'>Speech-Language Pathologist</div>
        <div className='serving-families-title'>
          <b>Servicing families across Metro Atlanta, Georgia</b>
        </div>
        <div className='specialties'>
          Pediatrics • Adults • Therapy • Assessment | In-home & Telehealth
        </div>

        <a href="https://calendly.com/speechwithbrandy" target="_blank" rel="noopener noreferrer">
          <StyledButton>Book Free Consultation</StyledButton>
        </a>
      </HeaderContainer>
    </MainContainer>
  );
};

export default Title;

const MainContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  padding: 90px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 40px 20px;
    gap: 1.5rem;
  }

  @media (max-width: 480px) {
    padding: 30px 15px;
    gap: 1rem;
  }
`;

const ProfileImg = styled.img`
  width: 280px;
  height: 280px;
  border-radius: 50%;
  object-fit: cover;
  background: linear-gradient(135deg, #f5f5dc 0%, #f0f4c3 100%);
  padding: 15px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    width: 220px;
    height: 220px;
  }

  @media (max-width: 480px) {
    width: 180px;
    height: 180px;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  text-align: left;

  .clinician-name,
  .clinician-title {
    font-size: 30px;
    font-weight: 600;
    color: #2c3e50;
    margin: 0;
  }

  .serving-families-title {
    color: #54a399ff;
    font-weight: 800;
    font-size: 16px;
  }

  .specialties,
  .description {
    font-size: 18px;
    font-weight: 400;
    color: #5d6d7e;
    margin: 0;
    margin-top: 0.5rem;
  }

  @media (max-width: 768px) {
    text-align: center;
    gap: 0.8rem;

    .clinician-name,
    .clinician-title {
      font-size: 24px;
    }

    .serving-families-title {
      font-size: 15px;
    }

    .specialties {
      font-size: 16px;
    }
  }

  @media (max-width: 480px) {
    gap: 0.6rem;

    .clinician-name,
    .clinician-title {
      font-size: 20px;
    }

    .serving-families-title {
      font-size: 14px;
    }

    .specialties {
      font-size: 14px;
    }
  }
`;

const StyledButton = styled(Button)`
  background: linear-gradient(135deg, #ff7043 0%, #ff5722 100%) !important;
  color: white !important;
  padding: 5px !important;
  border-radius: 10px !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  width: 200px;
  margin-top: 1rem !important;
  min-height: 40px !important;
  transition: transform 0.3s ease, box-shadow 0.3s ease !important;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(255, 112, 67, 0.4);
    background: linear-gradient(135deg, #ff5722 0%, #ff7043 100%) !important;
  }

  @media (max-width: 768px) {
    width: 180px;
    font-size: 14px !important;
    align-self: center;
  }

  @media (max-width: 480px) {
    width: 160px;
    font-size: 13px !important;
    min-height: 36px !important;
  }
`;
